<turbo-frame
  id="enterprise_banner_{{feature}}"
  *ngIf="visible"
  [src]="frameURL"
>
</turbo-frame>
